import _ from "lodash";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { GeneralApi } from "../../Api/General";
import { QuizAPI } from "../../Api/Quiz";
import { Button, Input, UploadButton } from "../../Components/CustomComponent";
import { Toast } from "../../Hooks/useToast";
import styles from "./index.module.scss";

export default function EditQuiz() {
  const quizAPI = QuizAPI();
  const generalApi = GeneralApi();

  const navigate = useNavigate();
  const location = useLocation();

  const isMultileFileUpload = useMemo(() => false, []);
  const fileAcceptParams = useMemo(() => "image/png, image/jpeg", []);
  const quiz = useMemo(() => location.state?.quiz, []);

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      title: quiz.title,
      description: quiz.description,
      contestant_count: quiz.contestant_count,
      audience_count: quiz.audience_count,
      audience_poll_duration: quiz.audience_poll_duration,
      expert_help_duration: quiz.expert_help_duration,
      google_help_duration: quiz.google_help_duration,
      cover_image_url: quiz.cover_image_url,
      start_at: moment(quiz.start_at).toDate(),
      end_at: moment(quiz.end_at).toDate(),
    }
  });

  const cover_image_url = watch('cover_image_url')
  const start_at = watch("start_at");
  const end_at = watch("end_at");

  const quizMutation = useMutation(quizAPI.edit, {
    onSuccess: (data) => {
      Toast("Quiz Updated successfully!", "success", false);
      navigate(-1);
    },
    onError: (err) => {
      Toast(err.message || "Something went wrong!", "error", false);
      setLoading(false)
    },
  });

  const uploadMutation = useMutation(generalApi.upload, {
    onSuccess: (data) => {
    },
    onError: (err) => {
      Toast(err.message, "error", false);
      setLoading(false);
    },
  });


  useEffect(() => {
    if (!start_at) return

    if (moment(start_at).isAfter(moment(end_at))) {
      setValue('end_at', moment(moment(start_at).add(15, 'minutes')).toDate())
    }
  }, [start_at])



  const handleAddfilesAndSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
    }
  };




  const onSubmit = async (data) => {
    if (loading) return;
    setLoading(true);

    if (file) {
      const formDataForUpload = new FormData();
      formDataForUpload.append("file", file);
      formDataForUpload.append("path", "quizzes");

      const uploadResponse = await uploadMutation.mutateAsync(
        formDataForUpload
      );
      data.cover_image_url = uploadResponse?.data[0];
    }

    data.start_at = moment(data.start_at).format()
    data.end_at = moment(data.end_at).format()
    quizMutation.mutate({ id: quiz.id, data });
  };

  return (
    <Container className={styles.EditQuiz}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col sm={12}>
            <UploadButton
              label="Upload Cover"
              classes="mb-2"
              labelClasses="p-5"
              isMultileFileUpload={isMultileFileUpload}
              fileAcceptParams={fileAcceptParams}
              file={_.isObject(file) ? file : cover_image_url}
              handleFileChange={handleAddfilesAndSelect}
            />
          </Col>

          <Col sm={12}>
            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Quiz Title"
                  placeholder="Add Here"
                  errors={errors}
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="contestant_count"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Contestant"
                  placeholder="1 - 99"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="audience_count"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Audience Count"
                  placeholder="1 - 99"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="start_at"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Start Date"
                  type="date"
                  minTime={
                    (!start_at || moment(start_at).isSame(new Date(), 'day'))
                      ? moment().toDate()
                      : undefined
                  } />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="end_at"
              control={control}
              render={({ field }) => (
                <Input {...field} label="End Date" type="date"
                  minDate={start_at ? moment(start_at) : moment()}
                  minTime={
                    (start_at && end_at && moment(start_at).isSame(moment(end_at), 'day'))
                      ? moment(moment(start_at).add(15, 'minutes')).toDate()
                      : undefined
                  }
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="audience_poll_duration"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Audience Poll Duration"
                  placeholder="60"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="expert_help_duration"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Expert Help Duration"
                  placeholder="60"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="google_help_duration"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Google Help Duration"
                  placeholder="60"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={12}>
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  as="textarea"
                  label="Description"
                  labelClasses="fs-7"
                  placeholder="Add Here"
                  rows={8}
                />
              )}
            />
          </Col>
        </Row>
        <Button
          type="submit"
          text={"Submit"}
          classes="mt-2"
          isSubmitted={loading}
        />
      </Form>
    </Container>
  );
}
